import { FiGithub, FiLinkedin } from "react-icons/fi";
import { MdEmail } from "react-icons/md";
import AppFooterCopyright from "./FooterCopyright";
// import VisitorCounter from "../VisitorCounter/VisitorCounter";

const socialLinks = [
  {
    id: 2,
    icon: <FiGithub />,
    url: "https://www.github.com/AnthonyTran",
  },
  {
    id: 4,
    icon: <FiLinkedin />,
    url: "https://www.linkedin.com/in/AnthonyTran/",
  },

  {
    id: 5,
    icon: <MdEmail />,
    url: "mailto:anthonytran1229@gmail.com",
  },
];

const AppFooter = () => {
  return (
    <div className="container mx-auto">
      <div className="pt-20 sm:pt-30 pb-8 border-t-2 dark:border-neutral-600 border-neutral-300">
  
        
        <AppFooterCopyright />
      </div>
    </div>
  );
};

export default AppFooter;
